<template>
  <div class="c-nav">
    <div class="c-nav-item" v-bind:class="{ current: activeTab == 0 }" v-on:click="selectTab(0)">
      Start
    </div>
    <div class="c-nav-item" v-bind:class="{ current: activeTab == 1 }"  v-on:click="selectTab(1)">
      Silnik i napęd
    </div>
    <div class="c-nav-item" v-bind:class="{ current: activeTab == 2 }"  v-on:click="selectTab(2)">
      Cena
    </div>
    <!-- <div class="c-nav-item" v-on:click="showForm()">
      Formularz kontaktowy
    </div> -->
    <div class="c-nav-item right" v-on:click="selectTab(999)">
      {{ModelCount}} Audi
    </div>
  </div>
</template>
<script>
export default {
  name: 'Nav',
  props: [
    'activeTab',
    'ModelCount'
  ],
  methods: {
    selectTab: function(tab){
      this.activeTab = tab;
      this.$emit('activeTab', this.activeTab)
    },
    showForm: function(){
      this.$emit('ShowForm', true)
    }
  }
}
</script>
<style lang="scss">
  .c-nav{
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    background-color: #000;
    display: flex;
    justify-content: flex-start;
    @media(max-width: 780px){
      display: block;
    }
    &-item{
      min-height: 55px;
      padding: 10px 40px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      line-height: 1rem;
      color:#b3b3b3;
      cursor: pointer;
      position: relative;
      @media(max-width: 780px){
        display: block;
        width: 100%;
        padding: 10px;
        min-height: 16px;
      }
      &::after{
        content: ' ';
        display: block;
        float: left;
        border-left: 1px solid #434c53;
        width: 1px;
        height: 28px;
        margin-left: 40px;
        position: absolute;
        right: 0;
        @media(max-width: 780px){
          display: none;
        }
      }
      &:hover{
        color: #fff;
      }
      &.right{
        margin-left: auto;
        background-color: #c03;
        font-weight: bold;
        color: #fff;
        font-size: .85rem;
        cursor: auto;
        &::after{display: none;}
      }
      &.current{
        background-color: #e7e9ea;
        color: #000;
        &::after{display: none;}
      }
      // &:first-of-type{
      //     &::after{display: none;}
      // }
    }
  }
</style>
